import {InstantClickListener} from './base/jquery-plugins/touch-click'

export function setupPlugins() {
	$.fn.touchSafeClick = function(func) {
		return (this as any).each(function(){
			new InstantClickListener($(this),func)
		})
	};

	($ as any).fn.andSelf = $.fn.addBack;
	($ as any).fn.curCSS = $.fn.css
}
